import styled from 'styled-components'

import typeStyle from 'styles/typeStyle'

import { frostedChipSurface } from '../../shared/chipSurface'
import Avatar from '../../../display/Avatar'
import LazyImage from '../../../display/LazyImage'

const LiteAvatar = styled(Avatar)<{ compact?: boolean }>`
  height: ${({ compact }) => (compact ? '18px' : '24px')};
  width: ${({ compact }) => (compact ? '18px' : '24px')};
  margin-right: ${({ compact }) => (compact ? '6px' : '8px')};
  flex-shrink: 0;
`

const Outer = styled.div<{ compact?: boolean }>`
  display: flex;
  align-items: center;
  width: fit-content;
  max-width: 100%;
  height: ${({ compact }) => (compact ? '24px' : '32px')};
  padding: ${({ compact }) => (compact ? '0 8px 0 3px' : '0 12px 0 4px')};

  border-radius: ${({ theme }) => theme['-ds-radius-round']};
  ${frostedChipSurface}
  color: ${({ theme }) => theme['-ds-text-primary']};
  ${typeStyle('-ds-font-caption-regular')}
  font-size: ${({ theme, compact }) =>
    compact
      ? theme['-ds-font-caption-sm'].fontSize
      : theme['-ds-font-caption-regular'].fontSize};

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

type Props = {
  storytellerName: string
  avatarUrl: string
  compact?: boolean
}

const StorytellerCreditLite = ({
  storytellerName,
  avatarUrl,
  compact,
}: Props) => {
  return (
    <Outer compact={compact}>
      <LiteAvatar compact={compact}>
        <LazyImage data-src={avatarUrl} alt={storytellerName} preload />
      </LiteAvatar>
      <span>Story by {storytellerName}</span>
    </Outer>
  )
}

export default StorytellerCreditLite
